import instance from './axios'

export const search = async (value) => {
  const { data } = await instance.post('/product-search', {
    name: value,
  })

  return data
}
